import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { ScanSearch } from "lucide-react";
import SkipTraceDialog from "./SkipTraceDialog";
import type { SkipTraceScope } from "@/enum/SkipTraceScope";

interface SkipTraceButtonProps {
  scope: SkipTraceScope;
  targetId: string;
  targetName?: string;
  iconOnly?: boolean;
  disabledReason?: string;
}

const SkipTraceButton: React.FC<SkipTraceButtonProps> = ({ scope, targetId, targetName, iconOnly, disabledReason }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <span title={disabledReason ?? "Skip Trace"} className="inline-flex">
        <Button
          variant="outline"
          size={iconOnly ? "icon" : "sm"}
          disabled={!!disabledReason}
          onClick={() => setOpen(true)}
        >
          <ScanSearch className="h-4 w-4" />
          {!iconOnly && <span className="ml-1">Skip Trace</span>}
        </Button>
      </span>
      <SkipTraceDialog
        scope={scope}
        targetId={targetId}
        targetName={targetName}
        open={open}
        onOpenChange={setOpen}
      />
    </>
  );
};

export default SkipTraceButton;
